import script from "./GeorgiaBenefitsDetailPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeorgiaBenefitsDetailPanel.vue?vue&type=script&setup=true&lang=ts"

import "./GeorgiaBenefitsDetailPanel.vue?vue&type=style&index=0&id=72fc211a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fc211a"]])

export default __exports__